export default "__VITE_ASSET__340dceb9__"